import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import React from 'react';
import { useParams } from 'react-router-dom';
import VendorStoreAutoOrderList from './VendorStoreAutoOrderList';
import generateAutoOrderData from '../commonFn/generateAutoOrderData';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';

// 스타일 변수
// const fontSize = 'min(3vw, 25px)';
const fontSize = 'max(1.2vw, 10px)';

const VendorStoreAutoOrder = () => {
    const { storeNo } = useParams();

    // 테스트용 자동 발주 내역 데이터 가져오기
    const testAutoOrderData = generateAutoOrderData(storeNo);

     // 생성된 데이터 확인

    return (
        <VerticalFlex
            backgroundColor="white"
            padding="max(1vw, 10px)"
            borderRadius="1rem"
        >
            <FlexChild alignItems="flex-start">
                <P size="max(1.4vw, 10px)" padding="0 0 1rem" weight={700}>
                    자동 발주 내역
                </P>
                <div
                    style={{
                        borderBottom: '1px solid #eee',
                    }}
                >
                    <HorizontalFlex padding="0 0 1rem" gap="1rem">
                        <FlexChild>
                            <P size={fontSize} weight={700}>
                                주문일
                            </P>
                        </FlexChild>
                        <FlexChild>
                            <P size={fontSize} weight={700}>
                                주문번호
                            </P>
                        </FlexChild>
                        <FlexChild>
                            <P size={fontSize} weight={700}>
                                주문자
                            </P>
                        </FlexChild>
                        <FlexChild>
                            <P size={fontSize} weight={700}>
                                상품명
                            </P>
                        </FlexChild>
                        <FlexChild>
                            <P size={fontSize} weight={700}>
                                수량
                            </P>
                        </FlexChild>
                        <FlexChild>
                            <P size={fontSize} weight={700}>
                                구매금액
                            </P>
                        </FlexChild>
                    </HorizontalFlex>
                </div>
                {/* <div>VendorStoreAutoOrder storeId : {storeNo}</div> */}
                {testAutoOrderData.map((order, index) => (
                    <VendorStoreAutoOrderList key={index} order={order} />
                ))}
            </FlexChild>
        </VerticalFlex>
    );
};

export default VendorStoreAutoOrder;
